export const setLoginAdmin = (status) => {
    return {
        type: "CHECK_LOGIN",
        status: status
    }
}